import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TicketImpresionService } from 'app/services/ticket-impresion.service';

@Component({
  selector: 'app-confirmacion-venta',
  templateUrl: './confirmacion-venta.component.html',
  styleUrls: ['./confirmacion-venta.component.css']
})
export class ConfirmacionVentaComponent {

  constructor(
    public dialogRef: MatDialogRef<ConfirmacionVentaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ticketService: TicketImpresionService
  ) { }

  /**
   * Obtiene la fecha y hora actual formateada
   */
  getCurrentDateTime(): string {
    const now = new Date();
    return now.toLocaleDateString('es-AR') + ' ' + now.toLocaleTimeString('es-AR', { hour12: false });
  }

  /**
   * Cierra el diálogo sin imprimir
   */
  cerrar(): void {
    this.dialogRef.close(false);
  }

  /**
   * Imprime el ticket y cierra el diálogo
   */
  imprimirTicket(): void {
    this.ticketService.imprimirTicketVenta(this.data.ventaData);
    this.dialogRef.close(true);
  }
}
